import { Button, Container, Text, Title } from '@sloyd/ui';
import classes from './Hero.module.css';
import { Video, Wrapper } from './Hero.style';

export type HeroProps = {
  onCta: () => void;
};

export function Hero(props: HeroProps) {
  return (
    <Wrapper className='Hero-wrapper' data-testid='Hero-wrapper'>
      <div className={classes.root}>
        <Container size='lg'>
          <div className={classes.inner}>
            <div className={classes.content}>
              <Title className={classes.title}>
                Generate and Tweak Parametric 3D models.{' '}
                <Text
                  component='span'
                  inherit
                  variant='gradient'
                  gradient={{ from: '#4A4A4A', to: '#2E2E2E', deg: 45 }}
                >
                  With a Prompt.
                </Text>{' '}
              </Title>

              <Text className={classes.description} mt={30}>
                Customizable models made by humans.
                <br /> Assembled and stylized by AI.
              </Text>
              <br />

              <Button
                variant='gradient'
                gradient={{ from: '#4A4A4A', to: '#2E2E2E', deg: 45 }}
                size='xl'
                radius='xl'
                className={classes.control}
                mt={40}
                onClick={props.onCta}
              >
                Try for Free
              </Button>
            </div>
            <Video autoPlay loop muted playsInline>
              <source
                // src='https://videos.pexels.com/video-files/5818973/5818973-uhd_2560_1440_24fps.mp4'
                src='/promo/movie_086.mp4'
                type='video/mp4'
              />
              Your browser does not support the video tag.
            </Video>
          </div>
        </Container>
      </div>
    </Wrapper>
  );
}

export default Hero;
